import React from 'react';
import reactDom from '../../../common/react/dom/index';
import Helpdesk from '../../../components/frontend/profile/helpdesk';

export default function init() {
	reactDom(<Helpdesk />, 'js-react-helpdesk');
}
